import React from 'react';
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    useMediaQuery,
    useTheme
} from '@material-ui/core';
import {Button} from '../../../../common/components/libs';
import {InvoiceServiceOrder} from '../../../../services/organizationBranches/models';
import {useStores} from '../../../../hooks';
import {TariffPeriod, TariffVariant} from '../../models';

interface ConfirmCancelInvoiceOrderFormProps {
    open: boolean,
    invoice: InvoiceServiceOrder | null,
    onSubmit: () => void
    onClose: () => void
}

export const ConfirmCancelInvoiceOrderForm: React.FC<ConfirmCancelInvoiceOrderFormProps> = ({ open, invoice, onSubmit, onClose }) => {

    const { constantsStore } = useStores();
    const currencyFormatter = constantsStore.getCurrencyFormatter('RUB');

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    const getTariff = (tariff: TariffVariant, period: TariffPeriod) => {
        let tariffStr = ''

        switch (tariff) {
            case 'Simple': {
                tariffStr = `Простой x `
                break
            }
            case 'Basic': {
                tariffStr = 'Базовый x '
                break
            }
            case 'Advanced': {
                tariffStr = 'Расширенный x '
                break
            }
        }

        switch (period) {
            case 'Month': {
                tariffStr += '1 мес'
                break
            }
            case 'HalfYear': {
                tariffStr += '6 мес'
                break
            }
            case 'Year': {
                tariffStr += '12 мес'
                break
            }
        }

        return tariffStr
    }

    return invoice ? <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
        fullScreen={!isSm}
    >
        <DialogTitle id="form-dialog-title">Вы уверены, что хотите отменить счёт?</DialogTitle>
        <DialogContent>
            <Box css={{ display: 'flex', flexDirection: 'column', gridGap: 5 }}>
                <Typography>
                    №{invoice.invoiceId}
                </Typography>

                <Typography>
                    Тариф: {getTariff(invoice.tariff, invoice.period)}
                </Typography>

                <Typography>
                    Сумма: {currencyFormatter.toShow(invoice.price.price)}
                </Typography>
            </Box>
        </DialogContent>
        <DialogActions>
            <Button variant={"contained"} color={"primary"} onClick={() => onSubmit()}>
                Отменить счёт
            </Button>
            <Button onClick={onClose} color="primary">
                Закрыть
            </Button>
        </DialogActions>
    </Dialog> : <></>
}